<template>
  <div class="myEvents">
    <el-main>
      <UserCenterTop />
      <el-row class="nofull event_content">
        <UserMenu :myMenuActiveId="myMenuActiveId" />
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>学者中心</el-breadcrumb-item>
            <el-breadcrumb-item>我的会议</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="row_header">
            <div class="row_title fl">我的会议</div>
            <div class="showSearch_btn">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-s-operation"
                @click="showSearch = !showSearch"
                >筛选</el-button
              >
            </div>
            <div v-show="showSearch" class="row_inside fr mobileShow">
              <div class="sec_row">
                <span class="timepicker_label">时间范围</span>
                <el-date-picker
                  size="small"
                  v-model="start_time"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions0"
                >
                </el-date-picker>
                <span style="display: inline-block; padding: 0 5px"> - </span>
                <el-date-picker
                  size="small"
                  style="margin-left: 0"
                  v-model="end_time"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                >
                </el-date-picker>
              </div>
              <div class="sec_row">
                <el-input
                  v-model="keyword"
                  size="small"
                  placeholder="请输入关键词"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="handleSearch"
                  >搜索</el-button
                >
              </div>
            </div>
            <!-- 以下div 是浏览器宽度768px以上显示 -->
            <div class="row_inside fr pcShow">
              <div class="sec_row">
                <span class="timepicker_label">时间范围</span>
                <el-date-picker
                  size="small"
                  v-model="start_time"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions0"
                >
                </el-date-picker>
                <span style="display: inline-block; padding: 0 5px"> - </span>
                <el-date-picker
                  size="small"
                  style="margin-left: 0"
                  v-model="end_time"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions1"
                >
                </el-date-picker>
              </div>
              <div class="sec_row">
                <el-input
                  v-model="keyword"
                  size="small"
                  placeholder="请输入关键词"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  plain
                  @click="handleSearch"
                  >搜索</el-button
                >
              </div>
            </div>
            <div style="clear: both; height: 0; overflow: hidden"></div>
          </div>
          <el-row class="eventsCheckbox">
            <div class="checkboxGroup">
              <div class="noflexLabel">筛选：</div>
              <el-radio-group v-model="radioChecked" @change="radioChange">
                <el-radio :label="1">全部</el-radio>
                <el-radio :label="2">已投稿</el-radio>
                <el-radio :label="3">已报名</el-radio>
              </el-radio-group>
            </div>
          </el-row>
          <!-- 我的会议列表 -->
          <el-row :gutter="30" style="position: relative; min-height: 400px">
            <div class="contentEmpty" v-if="this.lengthNumber === 0">
              暂无内容
            </div>
            <el-col :span="8" v-for="(item, index) in eventList" :key="index">
              <el-card :body-style="{ padding: '0px' }">
                <el-image
                  :src="
                    '/forum-pub-api/v1/minio/getFile?file_url=' + item.image_url
                  "
                  fit="cover"
                >
                  <div slot="error" class="image-slot">
                    <div class="errText">{{ item.name }}</div>
                    <img
                      class="el-image__inner"
                      style="object-fit: cover"
                      src="../assets/errbg.jpg"
                    />
                  </div>
                </el-image>
                <div class="card_content">
                  <!-- router-link可以像href一样跳转，query带id -->
                  <el-link
                    class="card_title"
                    @click="toMyRegistrationForm(item)"
                  >
                    {{ item.name }}
                  </el-link>
                  <!--
                                    <div class="signUpState">报名状态：<i class="el-icon-success"></i> {{ item.signUpState }}</div>
                                    <div class="submitState">投稿状态：<i class="el-icon-warning"></i>{{ item.submitState }}</div>
                                    -->
                  <div class="bottom clearfix">
                    <time class="time"
                      >{{ sDate }}：<span>{{
                        changetoLocaleString(item.start_time)
                      }}</span></time
                    >
                    <time class="time"
                      >{{ eDate }}：<span>{{
                        changetoLocaleString(item.end_time)
                      }}</span></time
                    >
                  </div>
                </div>
                <div class="card_btn">
                  <el-button @click="toMyRegistrationForm(item)"
                    ><b style="color: #409eff; font-size: 14px"
                      >查看报名表</b
                    ></el-button
                  >
                  <el-button @click="toMyThesisList(item)"
                    ><b style="color: #409eff; font-size: 14px"
                      >查看投稿</b
                    ></el-button
                  >
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-pagination
            :page-size="pageSize"
            style="margin-top: 20px"
            background
            layout="prev, pager, next"
            :current-page="currentPage"
            @current-change="currentChange"
            :total="total"
          >
          </el-pagination>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu.vue';
import UserCenterTop from '@/components/UserCenterTop.vue';
import { getMyEvents } from '@/apis/events.js';
export default {
  name: 'MyEvents',
  components: {
    UserMenu,
    UserCenterTop,
  },
  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');
    let currentPage = this.$route.query.page;
    this.currentPage = Number(currentPage);
    this.getMyEventList();
  },

  data() {
    return {
      myMenuActiveId: '1',
      lengthNumber: null,
      showSearch: '',
      start_time: '', // 搜索起始日期
      // 起始日期选择器时间范围限制
      pickerOptions0: {
        disabledDate: (date) => {
          if (this.end_time !== '' && this.end_time !== null) {
            return date.getTime() > this.end_time;
          } else {
            return date.getTime() === Date.now();
          }
        },
      },
      end_time: '', // 搜索结束日期
      // 结束日期选择器时间范围限制
      pickerOptions1: {
        disabledDate: (date) => {
          if (this.start_time !== '' && this.start_time !== null) {
            return date.getTime() < this.start_time;
          } else {
            return date.getTime() < Date.now();
          }
        },
      },
      keyword: '',
      radioChecked: 1,
      forum_manuscript_status: true,
      forum_registration_status: true,
      sDate: '开始时间',
      eDate: '结束时间',
      eventList: [],
      signUpState: '',
      submitState: '',
      total: null,
      currentPage: 1,
      pageSize: 12,
    };
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.$router.push({ path: '/myEvents', query: { page: 1 } });
      this.getMyEventList();
    },
    radioChange(val) {
      // console.log(val)
      if (val === 1) {
        this.forum_manuscript_status = true;
        this.forum_registration_status = true;
        this.handleSearch();
      } else if (val === 2) {
        this.forum_manuscript_status = true;
        this.forum_registration_status = false;
        this.handleSearch();
      } else if (val === 3) {
        this.forum_manuscript_status = false;
        this.forum_registration_status = true;
        this.handleSearch();
      }
    },

    getMyEventList() {
      getMyEvents({
        forum_registration_status: this.forum_registration_status,
        forum_manuscript_status: this.forum_manuscript_status,
        sort_order: 'desc',
        page: this.currentPage,
        page_size: this.pageSize,
        start_time: this.start_time,
        end_time: this.end_time,
        keyword: this.keyword,
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.success === true) {
              this.lengthNumber = res.data.data.items.length;
              this.eventList = res.data.data.items;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.message);
            }
            console.log(res.data);
          } else {
            this.$message.error('未请求成功');
            console.log('错误');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toMyRegistrationForm(item) {
      this.$router.push({
        path: '/myRegistrationForm',
        query: { eventId: item.forum_id },
      });
    },
    toMyThesisList(item) {
      this.$router.push({
        path: '/myThesisList',
        query: { eventId: item.forum_id },
      });
    },

    currentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.$router.push({
        path: '/myEvents',
        query: { page: this.currentPage },
      });
      this.getMyEventList();
    },
    changetoLocaleString(str) {
      if (str) {
        // let localeTime = new Date(str);
        // return this.common.dateFormat("YYYY/mm/dd", localeTime)
        return this.$moment(str).format('YYYY-MM-DD');
      } else {
        return str;
      }
    },
  },
};
</script>

<style scoped>
.el-radio-group {
  line-height: 30px;
  padding-top: 10px;
}
</style>
